import useErrorHandle from "hooks/useErrorHandle";
import useSearchIntentProjects from "shared/IntentProject/useSearchIntentProjects";
import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import useTitle from "hooks/useTitle";

import IntentProjectsEmpty from "./Empty";
import IntentProjectsTable from "./Table";
import IntentProjectsPageLayout from "./PageLayout";
import IntentProjectsFiltersLayout from "./FiltersLayout";
import IntentProjectAgreementBanner from "../IntentProject/AgreementBanner";

const IntentProjects = () => {
  const {
    intentProjects,
    error,
    loadingContent,
    isEmpty,
    searchIsEmpty,
    startCursor,
    endCursor,
    paginationResetKey,
  } = useSearchIntentProjects();

  const { accountName } = useTypedContext(AccountContext);

  useTitle(`Intent Projects · ${accountName}`);

  const ErrorContent = useErrorHandle(error);
  if (ErrorContent) {
    return ErrorContent;
  }

  return (
    <IntentProjectsPageLayout pageIsEmpty={isEmpty}>
      <IntentProjectAgreementBanner />
      <IntentProjectsFiltersLayout>
        {isEmpty && <IntentProjectsEmpty />}
        {searchIsEmpty && <IntentProjectsEmpty hasNoSearchResult />}

        {!isEmpty && !searchIsEmpty && (
          <IntentProjectsTable
            intentProjects={intentProjects}
            loading={loadingContent}
            startCursor={startCursor}
            endCursor={endCursor}
            resetKey={paginationResetKey}
          />
        )}
      </IntentProjectsFiltersLayout>
    </IntentProjectsPageLayout>
  );
};

export default IntentProjects;
